module.exports = (__webpack_require__("49fU"))(16);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/redux/es/index.js from dll-reference vendor_library
// module id = 2KeS
// module chunks = 24